<template>
  <div>
    <div class="roundedBorder">
      <el-button
        v-show="routes.length > 0"
        slot="reference"
        @click="exportExcel('Seguimiento')"
        style="background-color: transparent !important;
               border: transparent; font-size: 12px; padding: 0;"
        type="text"
        plain>
        <i class="el-icon-document" style="font-size: 15px; color: #AAD500"></i>
        &nbsp;EXCEL
      </el-button>
      <el-table :data="routes"
                tooltip-effect="dark"
                ref="tableRoutesActives"
                height="500px"
                size="mini"
                :default-sort="{prop: 'position', order: 'ascending'}"
                empty-text>
        <p slot="empty">SELECCIONA UNA EMPRESA O PATENTE</p>
        <el-table-column
          show-overflow-tooltip
          :min-width="80"
          label="RUTA">
          <template slot-scope="scope">
            {{ scope.row.routeId }}
          </template>
        </el-table-column>
        <el-table-column
          :min-width="70"
          :sortable="true"
          prop="position"
          label="PTO">
          <template slot-scope="scope">
            {{ scope.row.position }}
          </template>
        </el-table-column>
        <el-table-column
          :min-width="120"
          show-overflow-tooltip
          label="PATENTE">
          <template slot-scope="scope">
            {{ scope.row.patent }}
          </template>
        </el-table-column>
        <el-table-column
          :min-width="120"
          show-overflow-tooltip
          label="SOC">
          <template slot-scope="scope">
            <span v-if="scope.row.isValid">{{ scope.row.soc }}</span>
            <span v-else style="color: #F5A623">{{ scope.row.soc }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :min-width="100"
          show-overflow-tooltip
          label="LOCALIDAD">
          <template slot-scope="scope">
            {{scope.row.locality.toUpperCase()}}
          </template>
        </el-table-column>
        <el-table-column
          :min-width="100"
          show-overflow-tooltip
          label="CLIENTE">
          <template slot-scope="scope">
            {{scope.row.customerName.toUpperCase()}}
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          :min-width="100"
          show-overflow-tooltip
          label="VENTANA">
          <template slot-scope="scope">
            <span v-if="scope.row.winInit === undefined && scope.row.winFinish === undefined">
              ---
            </span>
            <span v-else>
              {{ scope.row.winInit }} - {{scope.row.winFinish }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          :min-width="60"
          show-overflow-tooltip
          label="ETA">
          <template slot-scope="scope">
            {{ scope.row.eta }}
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="REAL"
          show-overflow-tooltip
          :min-width="60">
          <template slot-scope="scope">
            {{ scope.row.real}}
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          label="ESTADO"
          show-overflow-tooltip
          :min-width="100">
          <template slot-scope="scope"
                    align="center">
            {{ typeStatus(scope.row.status) }}
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          :min-width="50">
          <template slot-scope="scope">
            <el-button
              style="font-size: 11px; color: #AAD500"
              type="text"
              @click="selectSoc(scope.row.soc)">VER</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import XLSX from 'xlsx';
import moment from 'moment';

export default {
  name: 'TracingRoutesTableV2',
  props: {
    routes: {
      type: Array,
    },
  },
  data() {
    return {
      routesActives: [],
      subordersData: [],
      status: [
        '',
        'DIGITADO',
        'PLANIFICADO',
        'EN RUTA',
        'PENDIENTE',
        'TERMINADO',
        'CANCELADO',
        'ACTUALIZADO',
      ],
    };
  },
  methods: {
    exportExcel(fileName) {
      // const data = XLSX.utils.json_to_sheet(this.routesActives);
      const excelData = this.routes.map((r) => {
        const data = {
          routeId: r.routeId,
          patent: r.patent,
          position: r.position,
          soc: r.soc,
          locality: r.locality,
          customerName: r.customerName,
          winInit: r.winInit,
          winFinish: r.winFinish,
          eta: r.eta,
          real: r.real,
          status: this.typeStatus(r.status),
        };
        return data;
      });
      const data = XLSX.utils.json_to_sheet(
        excelData,
        {
          header: [
            'routeId',
            'patent',
            'position',
            'soc',
            'locality',
            'customerName',
            'winInit',
            'winFinish',
            'eta',
            'real',
            'status',
          ],
        },
      );
      // eslint-disable-next-line
      data["A1"].v = 'RUTA';
      // eslint-disable-next-line
      data["B1"].v = 'PPU';
      // eslint-disable-next-line
      data["C1"].v = 'PUNTO';
      // eslint-disable-next-line
      data["D1"].v = 'SOC';
      // eslint-disable-next-line
      data["E1"].v = 'LOCALIDAD';
      // eslint-disable-next-line
      data["F1"].v = 'CLIENTE';
      // eslint-disable-next-line
      data["G1"].v = 'VENTANA INICIO';
      // eslint-disable-next-line
      data["H1"].v = 'VENTANA FIN';
      // eslint-disable-next-line
      data["I1"].v = 'ETA';
      // eslint-disable-next-line
      data["J1"].v = 'REAL';
      // eslint-disable-next-line
      data["K1"].v = 'ESTADO';
      const workbook = XLSX.utils.book_new();
      const filename = fileName;
      const date = moment();
      const dataExcel = moment(date).format('YYYY-MM-DD HH-mm');
      XLSX.utils.book_append_sheet(workbook, data, filename);
      XLSX.writeFile(workbook, `${filename} ${dataExcel}.xlsx`);
    },
    selectSoc(soc) {
      this.$emit('clickSoc', soc);
    },
    typeStatus(id) {
      const name = this.status[id];
      return name;
    },
    setData() {
      /*
      this.subordersData = this.routes;
      this.routesActives = [];
      console.time('setData');
      this.subordersData.forEach((o) => {
        o.socs.forEach((s) => {
          const dataRowSoc = {
            patent: s.patent,
            routeId: s.routeId,
            soc: s.soc,
            commune: s.commune,
            locality: s.locality,
            position: s.position + 1,
            winInit: moment.utc(s.winInit).format('HH:mm'),
            winFinish: moment.utc(s.winFinish).format('HH:mm'),
            eta: (s.position === null) ? 'L.E' : moment.utc(s.eta).format('HH:mm'),
            // eslint-disable-next-line
            real:
            (s.real === '0001-01-01T00:00:00Z') ? '--- : ---' : moment.utc(s.real).format('HH:mm'),
            customerName: s.customerName,
            status: s.status,
            isValid: o.id === s.routeId,
          };
          this.routesActives.push(dataRowSoc);
        });
      });
      console.timeEnd('setData');
      */
      this.$emit('loadTree', false);
    },
  },
  filters: {
    moment(time) {
      if (time) {
        const date = moment(time).format('HH:mm:ss');
        return date;
      }
      return '';
    },
    len(data) {
      if (data) {
        return data.length;
      }
      return 0;
    },
  },
  watch: {
    routes() {
      this.setData();
    },
  },
};
</script>

<style lang="scss" scoped>
  .roundedBorder {
    height: 275px;
  }
  .el-button.el-button--text {
    color: #a5a5a5;
    font-weight: bold;
    :hover {
      color: $fb-green;
    };
  }
  @media only screen and (max-width: 1200px) {
    .roundedBorder {
      height: 415px;
    }
  }

</style>
